import { render, staticRenderFns } from "./backModal.vue?vue&type=template&id=5e28a9ca"
import script from "./backModal.vue?vue&type=script&lang=js"
export * from "./backModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports